module.exports = __webpack_public_path__ + "static/img/UTM教室_3.b263d13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/UTM/UTM教室_3.png
// module id = 22AG
// module chunks = 0